interface CalculatedData {
  [age: number]: {
    [weight: number]: {
      full: number
      partial: number
      fullTrial: number
      partialTrial: number
    }
  }
}

export const ageBrackets = [
  {
    value: 1,
    label: 'Less than 1 year old'
  },
  {
    value: 2,
    label: '1-2 yrs'
  },
  {
    value: 3,
    label: '2-3 yrs'
  },
  {
    value: 4,
    label: '3-4 yrs'
  },
  {
    value: 5,
    label: '4-5 yrs'
  },
  {
    value: 6,
    label: '5-6 yrs'
  },
  {
    value: 7,
    label: '6-7 yrs'
  },
  {
    value: 8,
    label: '7-8 yrs'
  },
  {
    value: 9,
    label: '8+ yrs'
  }
]

export const weightBrackets = [
  {
    value: 1,
    label: '1-5 kg'
  },
  {
    value: 2,
    label: '6-10 kg'
  },
  {
    value: 3,
    label: '11-15 kg'
  },
  {
    value: 4,
    label: '16-20 kg'
  },
  {
    value: 5,
    label: '21-25 kg'
  },
  {
    value: 6,
    label: '26-30 kg'
  },
  {
    value: 7,
    label: '31-40 kg'
  },
  {
    value: 8,
    label: '41-50 kg'
  },
  {
    value: 9,
    label: '51-60 kg'
  },
  {
    value: 10,
    label: '61-75 kg'
  }
]

const duplicatedData = {
  1: { full: 83, partial: 0, fullTrial: 83, partialTrial: 0 },
  2: { full: 236, partial: 165, fullTrial: 236, partialTrial: 165 },
  3: { full: 330, partial: 189, fullTrial: 283, partialTrial: 165 },
  4: { full: 471, partial: 236, fullTrial: 330, partialTrial: 165 },
  5: { full: 440, partial: 330, fullTrial: 314, partialTrial: 236 },
  6: { full: 566, partial: 330, fullTrial: 440, partialTrial: 283 },
  7: { full: 629, partial: 377, fullTrial: 440, partialTrial: 330 },
  8: { full: 691, partial: 377, fullTrial: 503, partialTrial: 314 },
  9: { full: 880, partial: 440, fullTrial: 629, partialTrial: 314 },
  10: { full: 880, partial: 440, fullTrial: 629, partialTrial: 314 }
}

export const calculatedData: CalculatedData = {
  // -1yr
  1: {
    1: { full: 83, partial: 0, fullTrial: 83, partialTrial: 0 },
    2: { full: 330, partial: 165, fullTrial: 283, partialTrial: 165 },
    3: { full: 471, partial: 236, fullTrial: 330, partialTrial: 165 },
    4: { full: 566, partial: 330, fullTrial: 440, partialTrial: 283 },
    5: { full: 629, partial: 377, fullTrial: 440, partialTrial: 330 },
    6: { full: 691, partial: 377, fullTrial: 503, partialTrial: 314 },
    7: { full: 880, partial: 440, fullTrial: 629, partialTrial: 314 },
    8: { full: 880, partial: 440, fullTrial: 629, partialTrial: 314 },
    9: { full: 1131, partial: 566, fullTrial: 817, partialTrial: 440 },
    10: { full: 1320, partial: 691, fullTrial: 943, partialTrial: 440 }
  },
  // 1-2yr
  2: duplicatedData,
  // 2-3yr
  3: duplicatedData,
  // 3-4
  4: duplicatedData,
  // 4-5yr
  5: duplicatedData,
  // 5-6yr
  6: duplicatedData,
  // 6-7yr
  7: duplicatedData,
  // 7-8yr
  8: {
    1: { full: 83, partial: 0, fullTrial: 83, partialTrial: 0 },
    2: { full: 189, partial: 106, fullTrial: 236, partialTrial: 83 },
    3: { full: 330, partial: 165, fullTrial: 283, partialTrial: 165 },
    4: { full: 377, partial: 212, fullTrial: 283, partialTrial: 141 },
    5: { full: 471, partial: 236, fullTrial: 330, partialTrial: 165 },
    6: { full: 440, partial: 330, fullTrial: 314, partialTrial: 236 },
    7: { full: 566, partial: 330, fullTrial: 440, partialTrial: 283 },
    8: { full: 629, partial: 377, fullTrial: 440, partialTrial: 330 },
    9: { full: 691, partial: 377, fullTrial: 503, partialTrial: 314 },
    10: { full: 880, partial: 440, fullTrial: 629, partialTrial: 314 }
  },
  // 8+yr
  9: {
    1: { full: 83, partial: 0, fullTrial: 83, partialTrial: 0 },
    2: { full: 189, partial: 106, fullTrial: 236, partialTrial: 83 },
    3: { full: 330, partial: 165, fullTrial: 283, partialTrial: 165 },
    4: { full: 377, partial: 212, fullTrial: 283, partialTrial: 141 },
    5: { full: 471, partial: 236, fullTrial: 330, partialTrial: 165 },
    6: { full: 440, partial: 330, fullTrial: 314, partialTrial: 236 },
    7: { full: 566, partial: 330, fullTrial: 440, partialTrial: 283 },
    8: { full: 629, partial: 377, fullTrial: 440, partialTrial: 330 },
    9: { full: 691, partial: 377, fullTrial: 503, partialTrial: 314 },
    10: { full: 880, partial: 440, fullTrial: 629, partialTrial: 314 }
  }
}
